import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { imageUrl } from 'app/frontend/base/helpers'

type Props = {
  className?: string
  to: string
}

const JoinDiscordButton = ({ className, to }: Props) => {
  return (
    <a
      href={to}
      target='_blank'
      rel='noreferrer'
      className={cn(
        buttonVariants({ variant: 'outline' }),
        'flex items-center gap-2',
        className,
      )}
    >
      <img src={imageUrl('discord-logo-blue.svg')} className='w-5 shrink-0' />{' '}
      <span>Join Discord</span>
    </a>
  )
}

export default JoinDiscordButton
